export default __webpack_public_path__ + "static/media/spaceman.417fcf0b.png";